import { createContext, useContext } from 'react';
import type { EventBus } from '../core/EventBus';
import type { Store } from '../core/Store';
import type { UIRegistry } from '../core/UIRegistry';
import type { ResolvedConfig, PlatformCapabilities } from '../core/types';
import type { IEngine } from '../engine/IEngine';

export interface PlayerContextValue {
  eventBus: EventBus;
  store: Store;
  config: ResolvedConfig;
  getEngine: () => IEngine | null;
  uiRegistry: UIRegistry;
  capabilities?: PlatformCapabilities;
}

export const PlayerContext = createContext<PlayerContextValue | null>(null);

export function usePlayerContext(): PlayerContextValue {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error('usePlayerContext must be used within PlayerContext.Provider');
  return ctx;
}
